export default __webpack_public_path__ + "static/media/Etape5_Moulin_After_Filtre.5b091abc.jpg";